import { Box, Stack } from "@mui/material";
import { Outlet } from "react-router-dom";

const LoginLayout = () => (
  <Stack
    direction="row"
    justifyContent="center"
    alignItems="center"
    sx={{ height: "100vh" }}
  >
    <Box sx={{ width: "450px" }}>
      <Outlet />
    </Box>
  </Stack>
);

export default LoginLayout;
